function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { IconButton as MUIIconButton } from '@mui/material/';
const IconButtonForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MUIIconButton, _extends({
  sx: {
    background: '#E4EAEE'
  }
}, props, {
  ref: ref
})));
export const PixelIconButton = _ref => {
  let {
    size = 'large',
    ...props
  } = _ref;
  const allProps = {
    ...props,
    size
  };
  return /*#__PURE__*/React.createElement(IconButtonForwardRef, allProps);
};
export default PixelIconButton;